'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SuperAgentResource = exports.SuperagentResponse = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _response = require('../response');

var _response2 = _interopRequireDefault(_response);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _typeChecks = require('../typeChecks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuperagentResponse = exports.SuperagentResponse = function (_ResponseWrapper) {
    _inherits(SuperagentResponse, _ResponseWrapper);

    function SuperagentResponse() {
        _classCallCheck(this, SuperagentResponse);

        return _possibleConstructorReturn(this, (SuperagentResponse.__proto__ || Object.getPrototypeOf(SuperagentResponse)).apply(this, arguments));
    }

    _createClass(SuperagentResponse, [{
        key: 'status',
        get: function get() {
            return this.response.status;
        }
    }, {
        key: 'statusType',
        get: function get() {
            return this.response.statusType;
        }
    }, {
        key: 'text',
        get: function get() {
            return this.response.text;
        }
    }, {
        key: 'data',
        get: function get() {
            if (this.disableDeserialize) {
                return this.text;
            }

            return this.response.body;
        }
    }, {
        key: 'headers',
        get: function get() {
            return this.response.header;
        }
    }]);

    return SuperagentResponse;
}(_response2.default);

var SuperAgentResource = exports.SuperAgentResource = function (_GenericResource) {
    _inherits(SuperAgentResource, _GenericResource);

    function SuperAgentResource() {
        _classCallCheck(this, SuperAgentResource);

        return _possibleConstructorReturn(this, (SuperAgentResource.__proto__ || Object.getPrototypeOf(SuperAgentResource)).apply(this, arguments));
    }

    _createClass(SuperAgentResource, [{
        key: 'wrapResponse',
        value: function wrapResponse(response, error, req) {
            // eslint-disable-line class-methods-use-this
            var disableDeserialize = !(0, _typeChecks.hasValue)(req.get('Accept'));

            // For superagent, all 4XX/5XX response codes also return an error object. Since
            // tg-resources handles these errors in the GenericResource we need to only send
            // error object here if it is not due to a response code.
            //
            // Network errors in superagent don't have `err.status`

            return new SuperagentResponse(response, error && error.status === undefined ? error : null, disableDeserialize);
        }
    }, {
        key: 'createRequest',
        value: function createRequest(method, url, query, data) {
            // eslint-disable-line class-methods-use-this
            method = method.toLowerCase();

            var req = _superagent2.default[method](url);

            if (query) {
                req = req.query(query);
            }

            if (data) {
                req = req.send(data);
            }

            return req;
        }
    }, {
        key: 'doRequest',
        value: function doRequest(req, resolve) {
            // eslint-disable-line class-methods-use-this
            req.end(function (err, res) {
                resolve(res, err);
            });
        }
    }, {
        key: 'setHeader',
        value: function setHeader(req, key, value) {
            // eslint-disable-line class-methods-use-this
            return req.set(key, value);
        }
    }]);

    return SuperAgentResource;
}(_base2.default);